// extracted by mini-css-extract-plugin
export var adjacentSlide = "_od-9";
export var arrowButtonContainer = "_od-5";
export var arrowButtonIcon = "_od-6";
export var carouselArrowButton = "_od-2";
export var carouselElementContainer = "_od-1";
export var currentSlide = "_od-8";
export var left = "_od-3";
export var otherSlide = "_od-a";
export var productCarouselContainer = "_od-0";
export var right = "_od-4";
export var sliderOverflow = "_od-7";